import { Img, SvgStaticImage } from "@gromia/components/SvgStaticImage";
import * as s from "@gromia/components/theme/t.module.css";
import { useMedia } from "@gromia/utils/useMedia";
import cx from "classnames";
import { StaticImage } from "gatsby-plugin-image";
import React from "react";
import * as spriv from "./ExampleListingCard.module.css";

type Logo = { svg: Img; alt: string };

const logos: Array<Logo> = [
  {
    svg: require("./google-logo.svg"),
    alt: "google logo",
  },
  {
    svg: require("./idealista-logo.svg"),
    alt: "idealista logo",
  },
  {
    svg: require("./facebook-logo.svg"),
    alt: "facebook logo",
  },
  {
    svg: require("./casa-logo.svg"),
    alt: "casa logo",
  },
  {
    svg: require("./instagram-logo.svg"),
    alt: "instagram logo",
  },
  {
    svg: require("./immobiliare-logo.svg"),
    alt: "immobiliare logo",
  },
];

const Image = (props: { l: Logo; className?: string }) => (
  <SvgStaticImage
    src={props.l.svg}
    alt={props.l.alt}
    className={props.className}
  />
);

const ImageSide = (props: { l: Logo; className?: string }) => (
  <div
    className={cx(s.dFlex, s.alignItemsCenter, props.className)}
    style={{ minHeight: 48 }}
  >
    <Image l={props.l} />
  </div>
);

const LogoLeft = () => (
  <div
    className={cx(s.pt5, s.pr2, s.prLg5, s.textRight, s.flexFill)}
    style={{ width: "300px" }}
  >
    <ImageSide l={logos[0]} className={cx(s.justifyContentEnd, s.mb5)} />
    <ImageSide
      l={logos[1]}
      className={cx(s.justifyContentEnd, s.mb5, s.pr3, s.prLg4)}
    />
    <ImageSide
      l={logos[2]}
      className={cx(s.justifyContentEnd, s.pr5, s.prLg6)}
    />
  </div>
);

const LogoRight = () => (
  <div
    className={cx(s.pt5, s.pl2, s.plLg5, s.textLeft, s.flexFill)}
    style={{ width: "300px" }}
  >
    <ImageSide l={logos[3]} className={cx(s.mb5)} />
    <ImageSide l={logos[4]} className={cx(s.mb5, s.pl3, s.plLg4)} />
    <ImageSide l={logos[5]} className={cx(s.pl5, s.plLg6)} />
  </div>
);

const LogosAll = () => (
  <div className={cx(s.row, s.mb3)}>
    <div className={cx(s.col, s.col6, s.textCenter, s.mb3)}>
      <Image l={logos[0]} className={spriv.scale} />
    </div>
    <div className={cx(s.col, s.col6, s.textCenter, s.mb3)}>
      <Image l={logos[1]} className={spriv.scale} />
    </div>
    <div className={cx(s.col, s.col6, s.textCenter, s.mb3)}>
      <Image l={logos[2]} className={spriv.scale} />
    </div>
    <div className={cx(s.col, s.col6, s.textCenter, s.mb3)}>
      <Image l={logos[3]} className={spriv.scale} />
    </div>
    <div className={cx(s.col, s.col6, s.textCenter, s.mb3)}>
      <Image l={logos[4]} className={spriv.scale} />
    </div>
    <div className={cx(s.col, s.col6, s.textCenter, s.mb3)}>
      <Image l={logos[5]} className={spriv.scale} />
    </div>
  </div>
);

export const ExampleListingCard = (props: {
  pill: NonNullable<React.ReactNode>;
  customerName: NonNullable<React.ReactNode>;
  price: NonNullable<React.ReactNode>;
  title: NonNullable<React.ReactNode>;
  subtitle: NonNullable<React.ReactNode>;
}) => {
  const media = useMedia();
  return (
    <React.Fragment>
      {!media.md ? <LogosAll /> : null}
      <div className={cx(s.dFlex, s.justifyContentCenter, s.textLeft)}>
        {media.md ? <LogoLeft /> : null}
        <div
          className={cx(
            s.card,
            s.border0,
            s.shadowSm,
            s.rounded,
            s.overflowHidden,
            s.flexFill,
            s.flexGrow0,
          )}
          style={{ width: "280px", height: "auto" }}
        >
          <div className={s.positionRelative} style={{ height: "240px" }}>
            <StaticImage
              src="./exampleListingThumb1.jpg"
              alt=""
              className={cx(
                s.positionAbsolute,
                s.top0,
                s.w100,
                s.h100,
                s.zIndexN1,
              )}
            />
            <header
              className={cx(
                s.positionAbsolute,
                s.top0,
                s.right0,
                s.left0,
                s.p4,
              )}
            >
              <span className={cx(s.media, s.alignItemsCenter, s.textWhite)}>
                <div
                  className={cx(s.uAvatar, s.mr2)}
                  style={{ width: "35px", height: "35px" }}
                >
                  <StaticImage
                    src="./avatar1.jpg"
                    alt=""
                    className={s.roundedCircle}
                  />
                </div>
                <div className={s.mediaBody}>
                  <span>{props.customerName}</span>
                </div>
                <span
                  className={cx(
                    s.badge,
                    s.badgePill,
                    s.badgeSuccess,
                    s.badgeBigger,
                  )}
                >
                  {props.pill}
                </span>
              </span>
            </header>
            <div
              className={cx(
                s.positionAbsolute,
                s.right0,
                s.bottom0,
                s.left0,
                s.p4,
              )}
            >
              <span className={cx(s.fontSizeLarge1, s.textWhite)}>
                {props.price}
              </span>
            </div>
          </div>

          <div className={cx(s.cardBody, s.p4, s.bgWhite)}>
            <div className={s.fontSizeSmall1}>{props.title}</div>
            <span className={cx(s.textSecondary, s.fontSizeSmall1)}>
              {props.subtitle}
            </span>
          </div>
        </div>
        {media.md ? <LogoRight /> : null}
      </div>
    </React.Fragment>
  );
};
